import React from 'react';
import { painPoints } from '../data/painPoints';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function PainPoints() {
  return <section className="w-full bg-ink px-5 py-16 sm:py-24" aria-label="Does any of this sound familiar?" data-id="element-231" data-mp="26ypg31e3zaq8">
      <div className="mx-auto max-w-6xl" data-id="element-232" data-mp="2bwzctgfhejdy">
        <SectionHeading tone="dark" eyebrow="Does any of this sound familiar?" title="If You’ve Experienced Even One of These Situations, I Created This System With You in Mind." data-id="element-233" data-mp="2bvxzf5aztkt2" />

        <ul className="mt-12 grid gap-x-10 sm:grid-cols-2" data-id="element-234" data-mp="21x05fmussz2o">
          {painPoints.map(p => <li key={p.title} className="border-t border-white/15 py-6" data-id="element-235" data-mp="1o1o95b0zv0jn">
              <h3 className="font-heading text-xl font-semibold leading-snug text-gold" data-id="element-236" data-mp="1sz6lzci4tzwx">{p.title}</h3>
              <p className="mt-2 leading-relaxed text-white/80" data-id="element-237" data-mp="3ie4e88i208mx">{p.text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl space-y-4 text-center text-[1.07rem] leading-relaxed text-white/85" data-id="element-238" data-mp="3nalchviyw3dq">
          <p className="font-heading text-2xl font-medium text-white" data-id="element-239" data-mp="1u1lk2wuwp53k">And it shouldn’t have to feel this complicated.</p>
          <p data-id="element-240" data-mp="27ti9gt56x0w9">
            When you’re dealing with a complex pediatric case, the problem isn’t necessarily that you lack knowledge.
            Sometimes, the missing piece is a practical structure for organizing the knowledge you already have.
          </p>
          <p data-id="element-241" data-mp="1g3x2pz01sg39">
            That’s the idea behind the Praxis & Motor Planning Clinical Pathway™ — to help you move from isolated motor
            observations toward a more organized exploration of the case.
          </p>
        </div>
        <SectionCta tone="dark" label="Yes, I want a more structured approach" data-id="element-242" data-mp="1k2wf24o3zf4q" />
      </div>
    </section>;
}